import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TagDefinition } from '@app/models/automation/tag-definition.model';
import { BaseDeviceType } from '@app/models/disciplinemanagement/base-device-type.model';
import { TagDataTypeHelper } from '@app/models/shared/tag-datatype.enum';

@Component({
  selector: 'app-tag-definition-edit-modal',
  templateUrl: './tag-definition-edit-modal.component.html',
  styleUrls: ['./tag-definition-edit-modal.component.scss']
})
export class TagDefinitionEditModalComponent {
  @Input() isVisible = false;
  @Input() selectedTagDefinition: TagDefinition;
  @Input() filteredBaseDeviceTypes: BaseDeviceType[] = [];

  @Output() save = new EventEmitter<TagDefinition>();
  @Output() cancel = new EventEmitter<void>();

  dataTypeOptions = TagDataTypeHelper.getAllOptions();

  onSave() {
    this.save.emit(this.selectedTagDefinition);
  }

  onCancel() {
    this.cancel.emit();
  }
}

